import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { SessionService } from '../../woo_services.module/SessionService';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor(private sessionService: SessionService) {}

  handleError(error: any): void {
    // Angular / zone.js may wrap the thrown value, so dig out the underlying error.
    const underlyingError = error?.ngOriginalError ?? error?.originalError ?? error?.rejection ?? error;

    if (underlyingError instanceof HttpErrorResponse) {
      console.debug('Skipped Sentry capture for HttpErrorResponse', underlyingError);
      return;
    }

    const userId = this.sessionService.getUser()?.id;
    Sentry.withScope((scope) => {
      if (userId) {
        scope.setUser({ id: userId });
      }
      Sentry.captureException(underlyingError);
    });

    throw error;
  }
}
